// src/views/GlobtelEsim/GlobtelEsim.js
import "./EsimPlatform.css";
import { Helmet } from "react-helmet";

// Assets (podmień ścieżki do plików)
import logo from "../../assets/logo-gb.png";
import mailPng from "../../assets/mail.png";
import awardImg2025 from "../../assets/award2025.jpg";
import awardImg from "../../assets/award.jpg";

export default function GlobtelEsim() {
  const bulletHero = [
    "White‑label & API‑first",
    "Global carrier partnerships",
    "Real‑time usage & spend control",
  ];

  const features = [
    {
      k: "flex",
      t: "Carrier Flexibility",
      d: "Easily switch between carriers and plans without physical SIM swaps to secure best rates & coverage per market.",
    },
    {
      k: "cost",
      t: "Cost Efficiency",
      d: "Cut roaming fees and unlock competitive plans tailored to wholesale business models.",
    },
    {
      k: "seamless",
      t: "Seamless Connectivity",
      d: "Uninterrupted service for global travelers and IoT fleets—no border friction, no downtime.",
    },
    {
      k: "reach",
      t: "Global Reach",
      d: "Tap into GlobTel's partnerships with local carriers worldwide for superior quality and redundancy.",
    },
    {
      k: "rtm",
      t: "Real‑Time Management",
      d: "Monitor usage, automate alerts, and cap spend with live dashboards and APIs.",
    },
    {
      k: "wl",
      t: "White‑Label Ready",
      d: "Launch under your brand with flexible packaging, catalogs, and billing integrations.",
    },
  ];

  const reasons = [
    {
      k: "gtm",
      t: "Faster GTM",
      d: "Pre‑integrated carrier network and ready‑to‑use onboarding flows reduce time to revenue.",
    },
    {
      k: "monetize",
      t: "Faster Monetisation",
      d: "Bundle data packs, day passes, local profiles, or enterprise pools—priced your way.",
    },
    {
      k: "pane",
      t: "Single Pane Control",
      d: "Provision, activate, and manage profiles at scale. Full audit trails and role‑based access.",
    },
    {
      k: "api",
      t: "APIs & Webhooks",
      d: "Automate everything—from KYC to billing events to usage top‑ups—via secure APIs.",
    },
    {
      k: "analytics",
      t: "Analytics",
      d: "Understand adoption, ARPU, attach rates, and margins with exportable dashboards.",
    },
    {
      k: "security",
      t: "Compliance & Security",
      d: "Built with enterprise‑grade security, GDPR alignment, and carrier‑grade reliability.",
    },
  ];

  return (
    <main className="esim">
      <Helmet>
        <title>GlobTel eSIM — Switch. Scale. Monetize.</title>
      </Helmet>

      {/* Hero */}
      {/* Hero */}
      <header className="esim__hero" aria-label="Intro">
        <div className="esim__hero-inner">
          <div className="esim__hero-media">
            <img src={mailPng} alt="" loading="lazy" />
          </div>

          <div className="esim__hero-content">
            <h1 className="esim__title">
              Borderless Connectivity. Built to Monetize.
            </h1>
            <p className="esim__lead">
              Introduce eSIM at wholesale scale with carrier flexibility, global
              reach, and real‑time control. GlobTel’s eSIM platform lets you
              switch networks, optimize costs, and deploy white‑label offerings
              that partners will love.
            </p>
            <ul className="esim__bullets" aria-label="Highlights">
              {bulletHero.map((b) => (
                <li key={b}>✔ {b}</li>
              ))}
            </ul>
          </div>
        </div>
      </header>

      {/* Key Features */}
      <section className="esim__features" aria-label="Key features">
        <h2>Key Features</h2>
        <div className="tiles">
          {features.map((f) => (
            <article key={f.k} className="tile">
              <h3 className="tile__title">{f.t}</h3>
              <p className="tile__text">{f.d}</p>
            </article>
          ))}
        </div>
      </section>

      {/* Why Choose GLOBTEL */}
      <section className="esim__why" aria-label="Why choose Globtel">
        <header className="esim__why-head">
          <h2>Why Choose GLOBTEL</h2>
        </header>
        <div className="tiles">
          {reasons.map((r) => (
            <article key={r.k} className="tile">
              <h3 className="tile__title">{r.t}</h3>
              <p className="tile__text">{r.d}</p>
            </article>
          ))}
        </div>
      </section>

      {/* Award Recognition */}
      {/* Awards (replace both about__award sections) */}
      <section className="awardsPro" aria-label="Award recognition">
        <article className="awardsPro__card">
          <div className="awardsPro__content awardsPro__content--right">
            <h3 className="awardsPro__title">
              Four Prestigious Wins, Including First Place in
              <br />
              "Best eSIM Provider."
            </h3>
            <p className="awardsPro__lead">
              Globtel Triumphs at the Antonio Meucci Global Telco Awards 2025.
            </p>
            <a
              className="awardsPro__link"
              href="https://globtel.biz/uncategorized/antonio-meucci-2025-press-release/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Read full story
            </a>
          </div>
          <div className="awardsPro__media">
            <img
              src={awardImg2025}
              alt="Antonio Meucci Global Telco Awards 2025"
              loading="lazy"
            />
          </div>
        </article>

        <article className="awardsPro__card awardsPro__card--reverse">
          <div className="awardsPro__media">
            <img
              src={awardImg}
              alt="Antonio Meucci Global Telco Awards 2024"
              loading="lazy"
            />
          </div>
          <div className="awardsPro__content">
            <h3 className="awardsPro__title">
              Our services were recognized as the
              <br />
              “Most Innovative Roaming Solution.”
            </h3>
            <p className="awardsPro__lead">
              The honor was presented at the Antonio Meucci Global Telco Awards
              2024.
            </p>
            <a
              className="awardsPro__link"
              href="https://globtel.biz/uncategorized/success-on-antonio-meucci-awards-2024/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Read full story
            </a>
          </div>
        </article>
      </section>
    </main>
  );
}
